import React, {useEffect, useMemo, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";

function OrderConfirmation() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [redirectionUrl, setRedirectionUrl] = useState(null);
  const [redirectionMessage, setRedirectionMessage] = useState(null);

  const fallbackRedirect = useMemo(() => "https://tavahot.com", []);

  const goToRedirectionUrl = () => {
    window.location.replace(redirectionUrl || fallbackRedirect);
  };

  const goToOrderSummary = () => {
    navigate(`/order-summary/${orderId}`, {
      replace: true,
      state: { redirectionUrl, redirectionMessage },
    });
  };

  useEffect(() => {
    const stateUrl = location?.state?.redirectionUrl;
    const stateMsg = location?.state?.redirectionMessage;
    if (stateUrl || stateMsg) {
      if (stateUrl) setRedirectionUrl(stateUrl);
      if (stateMsg) setRedirectionMessage(stateMsg);
      try {
        if (orderId) {
          sessionStorage.setItem(
            `orderRedirect:${orderId}`,
            JSON.stringify({ redirectionUrl: stateUrl, redirectionMessage: stateMsg })
          );
        }
      } catch (e) {
        // ignore
      }
      return;
    }

    try {
      if (orderId) {
        const stored = sessionStorage.getItem(`orderRedirect:${orderId}`);
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            if (parsed?.redirectionUrl) setRedirectionUrl(parsed.redirectionUrl);
            if (parsed?.redirectionMessage) setRedirectionMessage(parsed.redirectionMessage);
          } catch (e) {
            // backward compatibility: stored as raw url string
            setRedirectionUrl(stored);
          }
        }
      }
    } catch (e) {
      // ignore
    }
  }, [location?.state, orderId]);

  // Clear back stack (block navigating back to Checkout). If back pressed, redirect to redirectionUrl.
  useEffect(() => {
    try {
      window.history.pushState({ orderConfirmation: true }, "", window.location.href);
    } catch (e) {
      // ignore
    }

    const onPopState = () => {
      goToRedirectionUrl();
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectionUrl]);

  return (
    <div className="pt-24 flex flex-col w-full h-full items-center bg-[#FBFCFF] px-4 pb-32">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold text-[#171725] mb-2">Your order is placed</h1>
        <div className="mt-4 rounded-lg bg-[#FBFCFF] p-4 border border-gray-100">
          <p className="text-[#171725] font-semibold">
            We’d love your feedback about the experience.
          </p>
          <p className="text-[#696974] mt-1">
            Once your order is served, we’ll send a WhatsApp message with a quick feedback link.
          </p>
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-10">
        <div className="w-full md:w-[40%] mx-auto">
          <button
            onClick={goToOrderSummary}
            disabled={!orderId}
            className="w-full bg-[#FBC02D] rounded-2xl py-3 text-lg font-semibold disabled:opacity-60"
          >
            View Order Summary
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmation;


